
import { call, put, takeLatest } from "redux-saga/effects";
import {
    GET_TAX_RULES,
    CREATE_TAX_RULE,
    UPDATE_TAX_RULE,
    DELETE_TAX_RULE,
    setTaxRules,
    setTaxRulesLoading,
    setCreateTaxRuleLoading,
    setUpdateTaxRuleLoading,
    setDeleteTaxRuleLoading,
} from "../../../actions/SocietyPortal/TaxRuleAction/TaxRuleAction";
import {
    getTaxRules,
    createTaxRule,
    updateTaxRule,
    deleteTaxRule,
} from "../../../../axios/request/SocietyPortal/TaxRuleReqs/TaxRuleReqs";
import { toast } from "react-toastify";

function* handleGetTaxRules(action) {
    try {
        yield put(setTaxRulesLoading(true));
        const { society_id } = action.payload; // Extract society_id from payload
        const response = yield call(getTaxRules, society_id);
        // Response is the body (refactored TaxRuleReqs checks axios status and returns data)
        if (Array.isArray(response)) {
            yield put(setTaxRules(response));
        } else if (response.success || Array.isArray(response.data)) {
             yield put(setTaxRules(response.data));
        } else {
             // Fallback
             yield put(setTaxRules([]));
        }
    } catch (error) {
        yield put(setTaxRules([]));
        toast.error(error?.response?.data?.message || "Something went wrong while fetching tax rules");
    } finally {
        yield put(setTaxRulesLoading(false));
    }
}

function* handleCreateTaxRule(action) {
    try {
        yield put(setCreateTaxRuleLoading(true));
        const { onSuccess, ...data } = action.payload;
        const response = yield call(createTaxRule, data);
        if (response.success) {
            toast.success(response.message || "Tax rule created successfully");
            if (onSuccess) onSuccess();
        } else {
            toast.error(response.message || "Failed to create tax rule");
        }
    } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong while creating tax rule");
    } finally {
        yield put(setCreateTaxRuleLoading(false));
    }
}

function* handleUpdateTaxRule(action) {
    try {
        yield put(setUpdateTaxRuleLoading(true));
        const { onSuccess, ...data } = action.payload;
        const response = yield call(updateTaxRule, data);
        if (response.success) {
            toast.success(response.message || "Tax rule updated successfully");
            if (onSuccess) onSuccess();
        } else {
            toast.error(response.message || "Failed to update tax rule");
        }
    } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong while updating tax rule");
    } finally {
        yield put(setUpdateTaxRuleLoading(false));
    }
}

function* handleDeleteTaxRule(action) {
    try {
        yield put(setDeleteTaxRuleLoading(true));
        const { id, onSuccess } = action.payload;
        const response = yield call(deleteTaxRule, id);
        if (response.success) {
            toast.success(response.message || "Tax rule deleted successfully");
            if (onSuccess) onSuccess();
        } else {
            toast.error(response.message || "Failed to delete tax rule");
        }
    } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong while deleting tax rule");
    } finally {
        yield put(setDeleteTaxRuleLoading(false));
    }
}

function* TaxRuleSaga() {
    yield takeLatest(GET_TAX_RULES, handleGetTaxRules);
    yield takeLatest(CREATE_TAX_RULE, handleCreateTaxRule);
    yield takeLatest(UPDATE_TAX_RULE, handleUpdateTaxRule);
    yield takeLatest(DELETE_TAX_RULE, handleDeleteTaxRule);
}

export default TaxRuleSaga;
